<template>
  <div>
    <div class="overlay psf l0 t0 r0 b0 vw100 vh100 xjc xac tac">
      <div>
        <div class="py2 px3">
          Dieses Formular ist leider nicht für mobile Endgeräte optimiert.
        </div>
        <div class="py2 px3">
          Unfortunately this form is not optimized for mobile screens.
        </div>
      </div>
    </div>
    <Header></Header>
    <main>
      <transition
        name="fade"
        mode="out-in"
      >
        <router-view></router-view>
      </transition>
    </main>
  </div>
</template>

<script>
import '../node_modules/gr8/dist/gr8.css'
import Header from './components/Header'

export default {
  name: 'App',
  components: {
    Header
  },
  mounted () {
    var language = navigator.language.substr(0, 2) || navigator.userLanguage.substr(0, 2)

    if (language === 'de') {
      this.$store.commit('setLanguage', 'de')
    } else {
      this.$store.commit('setLanguage', 'en')
    }
  }
}
</script>

<style>
@font-face {
  font-family: 'Sneak';
  src:
    url('assets/fonts/Sneak-Light.eot?#iefix') format('embedded-opentype'),
    url('assets/fonts/Sneak-Light.woff2') format('woff2'),
    url('assets/fonts/Sneak-Light.woff') format('woff');
  font-weight: lighter;
  font-style: normal;
}

@font-face {
  font-family: 'Sneak';
  src:
    url('assets/fonts/Sneak-Light-Italic.eot?#iefix') format('embedded-opentype'),
    url('assets/fonts/Sneak-Light-Italic.woff2') format('woff2'),
    url('assets/fonts/Sneak-Light-Italic.woff') format('woff');
  font-weight: lighter;
  font-style: italic;
}

@font-face {
  font-family: 'Sneak';
  src:
    url('assets/fonts/Sneak-Medium.eot?#iefix') format('embedded-opentype'),
    url('assets/fonts/Sneak-Medium.woff2') format('woff2'),
    url('assets/fonts/Sneak-Medium.woff') format('woff');
  font-weight: bold;
  font-style: normal;
}

:root {
  --sans: 'Sneak', sans-serif;
  --fg: #000;
  --fg-rgb: 0, 0, 0;
  --fg-light: #333;
  --bg: #fff;
  --acc: #a9a9a9;
  --focus: #afe4bc;
  /*--focus: #d5f1dc;*/
}

* {
  font-size: 18px;
  box-sizing: border-box;
  padding: 0;
  margin: 0;
}

*:before,
*:after {
  box-sizing: inherit;
}

html {
  height: 100%;
}

body {
  font-family: var(--sans);
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-size: 1rem;
  line-height: 1.4;
  font-weight: lighter;
  color: var(--fg);
  background: var(--bg);
}

.overlay {
  display: none;
  background: var(--bg);
}

@media (max-width: 740px) {
  .overlay {
    z-index: 999;
    display: flex;
  }
}

h1,
h2,
h3 {
  font-size: 2rem;
  font-weight: lighter;
  margin-bottom: 1rem;
}

h3 {
  font-size: 1rem;
  font-weight: bold;
}

a {
  color: inherit;
}

a:hover {
  color: var(--acc);
}

.active {
  color: var(--acc);
}

p {
  max-width: 36rem;
  padding-bottom: 1rem;
}

main {
  position: relative;
  min-height: 100vh;
  padding-top: 3rem;
  padding: 1rem;
}

.wrapper {
  padding-bottom: 3rem;
}

.form-wrapper {
  border-top: 1px solid var(--fg);
  width: 100%;
}

form {
  border-bottom: 1px solid var(--fg);
  margin-top: -1px;
}

.input-wrapper {
  border-top: 1px solid var(--fg);
}

.py0-5 {
  padding-top: 0.4rem;
  padding-bottom: 0.4rem;
}

.button {
  left: 0;
  right: 0;
  bottom: 0;
  height: 3rem;
  line-height: 1;
  color: var(--bg);
  background: var(--fg-light);
  padding: 1rem;
  transition: all 0.3s ease;
}

.button:hover {
  color: var(--fg);
  background: var(--focus);
  transition: all 0.3s ease;
}

.button a {
  display: flex;
  justify-content: space-between;
  align-items: center;
  text-decoration: none;
}

span {
  font-size: inherit;
}

label,
.label {
  font-size: 0.8rem;
  padding-right: 0.5rem;
}

input,
select,
textarea,
.field {
  width: 100%;
  font-family: var(--sans);
  font-size: 1rem;
  font-weight: lighter;
  color: var(--fg);
  background: var(--bg);
  border: 1px solid var(--fg);
  border-right: 0;
  border-radius: 0;
  padding: 0.5rem;
  margin-top: -1px;
  margin-bottom: -1px;
}

.field {
  font-size: 0.8rem;
}

input:focus,
select:focus,
textarea:focus {
  background: var(--focus);
  outline: none;
}

button:focus {
  outline: none;
}

select {
  -moz-appearance: none;
  -webkit-appearance: none;
  appearance: none;
}

select:hover {
  cursor: pointer;
}

textarea {
  font-weight: lighter;
  line-height: inherit;
  vertical-align: top;
  resize: none;
}

button {
  cursor: pointer;
  width: 100%;
  font-family: var(--sans);
  font-size: 1rem;
  font-weight: lighter;
  color: var(--bg);
  background: var(--fg-light);
  border: 0;
  padding: 0.5rem;
  transition: all 0.3s ease;
}

button:hover {
  color: var(--fg);
  background: var(--focus);
  transition: all 0.3s ease;
}

.less {
  opacity: 0.1;
}

#toggle {
  width: 4rem;
  text-align: center;
  color: var(--bg);
  background: rgba(var(--fg-rgb), 0.8);
  padding: 0.5rem;
}

.required {
  font-weight: bold;
}

.required:after {
  content: ' *';
}

.field p {
  font-size: 0.8rem;
}

.field p:last-child {
  padding: 0;
  margin: 0;
}

.input-wrapper {
  border-top: 1px solid var(--fg);
  border-bottom: 1px solid var(--fg);
  margin-top: -1px;
  margin-bottom: -1px;
}

.errors {
  color: red;
  list-style: none;
}

.errors li:before {
  content: '⟼ '
}

.bold {
  font-weight: bold;
}

.absolute {
  position: absolute;
}

textarea {
  white-space: pre-wrap;
}

.selector {
  position: relative;
}

.selector:after {
  position: absolute;
  right: 0;
  top: 0;
  bottom: 0;
  content: '↧';
  color: var(--bg);
  background: rgba(var(--fg-rgb), 0.8);
  text-align: center;
  pointer-events: none;
  padding: 0.5rem 0.8rem;
}

.smallButton {
  position: fixed;
  left: 1rem;
  bottom: 4rem;
  border: 1px solid var(--fg);
  padding: 0.5rem;
  transition: all 0.3s ease;
}

.smallButton:hover {
  color: var(--fg);
  background: var(--focus);
  transition: all 0.3s ease;
}

.fade-enter-active,
.fade-leave-active {
  transition-duration: 0.3s;
  transition-property: opacity;
  transition-timing-function: ease;
}

.fade-enter,
.fade-leave-active {
  opacity: 0
}
</style>
